module.exports = __webpack_public_path__ + "img/dates2.045a590d.svg";